import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { InventoryBasicSetupFieldEnum as Fields } from 'Common/FieldEnum';
import { InputField } from 'Common/SemanticWrapper';
import { StyledReduxFormError } from 'Components';

class InventoryBasicSetupForm extends Component {
  static defaultProps = {
    error: '',
    handleSubmit: () => {},
  };
  static propTypes = {
    handleSubmit: PropTypes.func,
    error: PropTypes.string,
  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.valid !== this.props.valid) {
      this.props.setIsValid(nextProps.valid);
    }
  }

  render() {
    const { handleSubmit, error } = this.props;

    return (
      <div>
        <Form onSubmit={handleSubmit}>
          <Field name={Fields.Id} component="input" type="hidden" />
          <Field
            name={Fields.Description}
            component={InputField}
            type="text"
            maxLength={30}
            label={'Description'}
          />
          <StyledReduxFormError error={error} />
        </Form>
      </div>
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  if (
    !values[Fields.Description] ||
    _.trim(values[Fields.Description]).length === 0
  ) {
    errors[Fields.Description] = 'Description is required';
  } else {
    const foundDescription = _.find(props.setUpData, x => {
      return (
        x.Description.toLowerCase() === values[Fields.Description].toLowerCase()
      );
    });
    if (foundDescription) {
      errors[Fields.Description] = `${props.humanName} already exists`;
    }
  }

  return errors;
};

export default reduxForm({
  validate,
  form: 'InventoryBasicSetupForm',
})(InventoryBasicSetupForm);



// WEBPACK FOOTER //
// ./src/pages/inventory/inventorybasicsetup/components/InventoryBasicSetupForm.js